import type * as ents from '@attain-apps/entities'
import type * as chartJs from 'chart.js'

/**
 * Get {@link ents.core.display.chart.data.Slice} from chart data based on index
 * from active elements
 */
export function getSliceByIndex(
  data: ents.core.display.chart.data.Of<ents.core.display.chart.Type.Donut>,
  elements: chartJs.ActiveElement[],
): ents.core.display.chart.data.Slice | undefined {
  const elementIndex: number | undefined = elements[0]?.index
  return elementIndex !== undefined ? data.slices?.[elementIndex] : undefined
}
